module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("SECTION 1: VIRGIN CROSS COUNTRY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("he Inter City Cross Country franchise was awarded to VRG by the Office of Passenger Rail Franchising (OPRAF) in November 1996 and a new subsidiary company called Cross Country Trains Ltd, trading as Virgin Cross Country, was created to operate the services from 5 January 1997 until 10 November 2007. During the franchise period, Railtrack entered administration and was replaced by Network Rail whilst the franchise role of OPRAF was assumed by the Strategic Rail Authority (SRA) which had come into existence on 1 February 2001 under the aegis of the Transport Act 2000. The failure of Railtrack to provide the infrastructure to permit the Inter City West Coast franchise to operate 140mph services led the SRA to suspend both VRG franchises in favour of Management Contracts in July 2002. The SRA was later abolished by the Transport Act 2005 and its functions were transferred to the Department for Transport (DfT) on 1 December 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("VCC inherited a mixed fleet comprising Class 43 High Speed Trainsets (HST), Class 47 diesel locomotives, Class 86 electric locomotives and Class 158 Diesel Multiple Units. A requirement of the franchise was the replacement of these by more modern trainsets, hence orders were placed for seventy-eight diesel-electric multiple unit trainsets designated ‘Voyager’ namely thirty-four four-car trainsets classified Class 220 and forty five-car plus four four-car tilting trainsets classified Class 221; these were delivered between 2001 and 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The company also inherited a diverse range of services stretching from Aberdeen and Glasgow in the north to the South Coast and Cornwall in the south which had only been melded into an integrated network in the previous decade before privatisation hence the mix of traction that was inherited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the new trainsets were introduced, a new timetable was devised, based on services geared to Birmingham New St as the hub from which they would operate on a clock face pattern. These services were to be provided by the short-rake ‘Voyager’ trainsets in which frequency would compensate for shorter trains to provide increased seating. The new timetable was introduced in September 2002 under the banner ‘Operation Princess’ but it quickly succumbed to technical failures of trainsets and Network Rail’s failure to upgrade the infrastructure hence leading the SRA to demand a cull of services. This led to the concentration of services on a core network and the withdrawal of services to centres such as Blackpool, Brighton, Liverpool, Portsmouth, Swansea and Weymouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were further consequences of the failure. A fleet of eight short-formed HSTs (2+5 formation), designated ‘Challenger’, had been created to support the ‘Voyager’ fleet but the conversion of further trainsets was cancelled whilst plans to expand the network and upgrade all the ‘Voyager’ trainsets to five-car formation were dropped. The major consequence of the failure, however, was the decision of the SRA in June 2006 to restructure the VRG franchises that included the transfer of the Birmingham New St-Edinburgh/Glasgow services to the Inter City West Coast franchise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SRA initially sought proposals from VRG for the operation of both franchises but the DfT, as successors to the SRA, rejected those for the Cross Country franchise and initiated an open tender which was won by Arriva Trains that began operating on 11 November 2007.")]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec01"
    }
  }, [_vm._v("1.1: CLASS 43-HIGH SPEED TRAINSETS (HST)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Virgin Cross Country inherited 27 High Speed Trainsets allocated between two depots; Edinburgh Craigentinny (coded ICCS) and Plymouth Laira (coded ICCP) whose allocation of the power cars at takeover was:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ICCP: 43008"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_**",
      "id": "fnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v("/087/088/089/090/091/101/102/103/121/122/153/154/155/156/157/158/159/160/161/162/ 178"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v("/184"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v("/193/194/195/196/197/198.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ICCS: 43006"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v("/007"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v("/013"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*",
      "id": "fnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/014"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/062/063/065"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/067"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/068"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/069/070/071/078/079/080"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/084"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v("/086/092/093/094/ 097/098/099/100/123"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("In 2001, Virgin Cross Country formed eight five-car trainsets, designated ‘Challenger’, to support the ‘Voyager’ Class 220/221 trainsets then being introduced to service; the failure of ‘Operation Princess’ (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec05"
    }
  }, [_vm._v("Section 1.5")]), _vm._v(") saw the cancellation of the additional ‘Challenger’ trainsets that had been planned.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 1):")])]), _vm._v(" Between 1997 and 2007 the main WCML route was shared by both Virgin Cross Country and Virgin West Coast franchises as noted in January 2005 when a Class 220 ‘Voyager’ trainset heading north out of Preston was viewed from St Michael’s church tower when passing a southbound Class 390 ‘Pendolino’ trainset approaching Preston station.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("In the early days of the franchise the HST power cars retained their Inter City branding as noted on …")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 2):")])]), _vm._v(" … 1 May 1999 when power car 43195 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Red Cross")]), _vm._v(" sped through Balshaw Lane Junction whilst leading an Edinburgh-Penzance service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 3):")])]), _vm._v(" … 13 April 1998 when an unidentified power car formed the rear of a Plymouth-Aberdeen service as it crosses the Forth Bridge on its northbound journey.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 4):")])]), _vm._v(" … 22 July 2000 when power car 43007 passed Oubeck whilst leading an Edinburgh-Bournemouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 5):")])]), _vm._v(" … 12 April 1997 when power car 43062 curved through Oubeck whilst leading an Edinburgh-Bournemouth service.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("The initial livery change came in May 1997 when power cars 43063/43090 were introduced with a red/black livery and a Virgin ‘XC’ branding; the ‘XC’ branding was quickly removed to leave the base Virgin Rail Group branding that was adopted for both its franchises. The only way to then differentiate Virgin Cross Country from Virgin Trains HST trainsets was that the former operated 2+7 trainsets whilst the latter operated 2+8 trainsets.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 6):")])]), _vm._v(" Power car 43063 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maiden Voyager")]), _vm._v(", the first of two to bear Virgin Cross Country branding, forms the rear of an Edinburgh-Penzance service as it passes Beckfoot on 31 May 1997.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 7):")])]), _vm._v(" Power car 43063 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maiden Voyager")]), _vm._v(", devoid of Virgin Cross Country branding, curves through Winwick on 4 July 2000 whilst leading a Penzance-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 8):")])]), _vm._v(" Power car 43155 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("City of Aberdeen")]), _vm._v(" carries the original Virgin Cross Country branding as it curves through Teignmouth on 27 April 2000 whilst leading a Paignton-Newcastle service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 9):")])]), _vm._v(" Power car 43070 curves through Beckfoot on 28 May 2002 whilst leading a Glasgow Central-Penzance service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 10):")])]), _vm._v(" Power car 43093 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lady in Red")]), _vm._v(" awaits departure from Wigan North Western on 10 September 2002 whilst forming the rear of an Edinburgh-Bournemouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 11):")])]), _vm._v(" Power car 43154 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Intercity")]), _vm._v(" curves through Greenholme on 30 January 2003 whilst leading a Plymouth-Edinburgh service as it ascends Shap.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 12):")])]), _vm._v(" In addition to the initial ‘XC’ branding the first re-painted power cars bore a ‘Flying Angel’ logo but this was quickly dropped to leave the power cars of both Virgin franchises with a standard livery and branding combination.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 13):")])]), _vm._v(" Power car 43098 speeds through Winwick on 22 October 1997 whilst leading an Aberdeen-Plymouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 14):")])]), _vm._v(" Power car 43102 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HST Silver Jubilee")]), _vm._v(" leads a northbound Cross Country service through Slindon on 12 August 2003.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 15):")])]), _vm._v(" Power car 43160 leads a Newcastle-Plymouth service along the sea wall at Teignmouth on 30 April 2000.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 16):")])]), _vm._v(" Power car 43091 leads a Plymouth-Aberdeen service through Winwick on 26 September 2002.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("In 2001 VCC decided to create a fleet of 2+5 HST trainsets, designated ‘Challenger’, to support the ‘Voyager’ trainsets and initially formed eight trainsets with the intention of producing more. Following the collapse of ‘Operation Princess’ and the consequent reduction of services, further ‘Challenger’ orders were cancelled and all Virgin Cross Country HST trainsets were withdrawn in September 2003 at the behest of the SRA.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 17):")])]), _vm._v(" Power car 43155 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("City of Aberdeen")]), _vm._v(" awaits departure from Blackpool North on 18 February 2003 whilst leading a service to Birmingham International.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 18):")])]), _vm._v(" Power car 43088 curves through Winwick on 18 October 2002 whilst leading a Blackpool North-Birmingham International service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 19):")])]), _vm._v(" Power car 43196 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Newspaper Society Founded 1836")]), _vm._v(" curves through Winwick on 11 December 2002 whilst leading a Preston-Birmingham International service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 20):")])]), _vm._v(" Power car 43162 curves through Beckfoot on 31 January 2003 whilst leading a Glasgow Central-Bournemouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 21):")])]), _vm._v(" Power car 43198 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HMS Penzance")]), _vm._v(" awaits departure from Reading on 29 April 2003 whilst reversing a Bournemouth-Glasgow Central service to continue northwards via Oxford and Birmingham.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("The final Virgin Cross Country HST services were operated on 29 September 2003 when two 2+6 trainsets were provided.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 22):")])]), _vm._v(" An unidentified power car powers through Defford whilst leading the Penzance-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 23):")])]), _vm._v(" Power car 43092 curves through Portway whilst leading the Dundee-Newquay service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The initial introduction of the ‘Voyager’ fleet (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec05"
    }
  }, [_vm._v("Section 1.5")]), _vm._v(") led to ten power cars being released to other operators (43007/104/166/178/184 to Midland Main Line; 43006/008 to Great North Eastern Railways; 43013/014/062 to Network Rail). The remaining forty-seven power cars were split into three sub-groups – ‘Challenger’ based at Longsight to be maintained by Alstom; ‘Pioneer’ and ‘Inter City West Coast’ based at Laira to be maintained by Bombardier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ‘Challenger’ fleet was intended to comprise seventeen 2+5 trainsets of which eight were initially created but the failure of ‘Operation Princess’ (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec05"
    }
  }, [_vm._v("Section 1.5")]), _vm._v(") led to cancellation of the project and cessation of Cross Country operation in September 2003. The redundant power cars were transferred to the Midland Main Line franchise from May 2003 to provide trainsets for its Project Rio – the operation of St Pancras-Manchester services that operated between May 2003 and September 2004 as replacement for the Manchester-Euston services which were reduced during upgrade engineering works on the WCML.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ‘Pioneer’ fleet comprised six trainsets that were retained to cover late deliveries of ‘Voyager’ trainsets plus four trainsets to cover WCML Euston-Blackpool/Holyhead services. The ‘Pioneer’ fleet became redundant in September 2003 with the power cars transferring to Project Rio whilst the WCML fleet became redundant in May 2004 and the power cars were stored pending transfer to other operators. Power cars 43092/094/097/098/153 remained in use to power summer dated Cross Country services after which they were stored until sold to First Group.")]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("1.2: CLASS 47")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Virgin Cross Country inherited a fleet of 26 Class 47/8 locomotives; these were Class 47/4 locomotives fitted with extra fuel tanks to cover the lengthy journeys over its non-electrified routes. The new franchisee created two locomotive pools for the fleet; ILRA to include Crewe-based locomotives and ILRB for locomotives available for ‘spot hire’ with allocations as under.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ILRA: 47805/806/810/812/814/818/822/825/826/827/828/829/831/839/840/841/843/844/847/848/849/851/ 853/854")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ILRB: 47807/817")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Porterbrook Leasings, from whom Virgin Cross Country leased its Class 47/8 fleet, had re-engineered a number of Freightliner Class 47 locomotives to create a new Class 57/0 fleet and speculatively re-engineered further examples for passenger use that were classified Class 57/3. Virgin Trains contracted to lease these for its Inter City services (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section 2.3")]), _vm._v(") and later conversions required locomotives from the ILRA pool which Porterbrook Leasings replaced with 5 Class 47/7 locomotives (47722/741/747/750/769) that had previously been leased to English Scottish Welsh Railways (EWSR). These were repainted into the Virgin Rail Group livery to denote the change of operator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the Class 47 fleet was withdrawn from Virgin Cross Country service in August 2002, some class members were transferred to Virgin Trains (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section 2.2")]), _vm._v("), whilst others were either scrapped or sold on to other operators.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 24):")])]), _vm._v(" 47826 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Springburn")]), _vm._v(" speeds through Leyland on 14 February 2002 whilst working a Bournemouth-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 25):")])]), _vm._v(" 47831 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bolton Wanderer")]), _vm._v(" curves past Dawlish Warren on 26 April 2000 whilst working a Liverpool Lime St-Plymouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 26):")])]), _vm._v(" 47812 enters Stockport on 14 July 1997 whilst working a Manchester Piccadilly-Brighton service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 27):")])]), _vm._v(" 47854 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Women’s Royal Voluntary Service")]), _vm._v(" climbs through Chorley on 24 June 1999 whilst working a Glasgow Central-Penzance service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("The Virgin Rail Group corporate livery was soon applied to the Class 47 fleet.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 28):")])]), _vm._v(" 47812 approaches Leyland on 18 October 2001 whilst working an Edinburgh-Brighton service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 29):")])]), _vm._v(" 47843 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vulcan")]), _vm._v(" awaits departure from Stockport on 17 August 2002 whilst working a Paddington-Manchester Piccadilly service in top ‘n’ tail mode with 47818 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strathclyde")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 30):")])]), _vm._v(" 47810 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Porterbrook")]), _vm._v(" enters Runcorn on 2 March 2002 whilst working a Liverpool Lime St-Poole service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("In 2001 Porterbrook Leasings withdrew some Class 47/8 locomotives from the leased fleet to re-engineer them into further examples of Class 57/3 locomotives (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section 2.3")]), _vm._v(") and replaced them with 5 Class 47/7 locomotives (47722/741/747/750/769) replete with Virgin Rail Group livery.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 31):")])]), _vm._v(" 47722 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Queen Mother")]), _vm._v(" races through Leyland on 20 December 2001 whilst working a Glasgow Central-Penzance service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 32):")])]), _vm._v(" 47747 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Graham Farish")]), _vm._v(" races through Leyland on 29 December 2001 whilst working a Glasgow Central-Penzance service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 33):")])]), _vm._v(" 47750 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlas")]), _vm._v(" awaits departure from Preston on 23 December 2001 whilst working a Glasgow Central-Paddington service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 34):")])]), _vm._v(" 47741 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Resilient")]), _vm._v(" races past Forton on 18 May 2002 whilst working a Birmingham International-Edinburgh service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the final years of operating Class 47/8 traction, Virgin Cross Country decided to re-livery some of its locomotives with heritage liveries previously borne by them in British Rail service whilst Porterbrook Leasings also chose to re-livery 47817 with its corporate livery albeit with a different scheme on both sides of the locomotive. Both liveries were noted at Stockport on 9 June 1997 when 47817 …")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 35):")])]), _vm._v(" … arrived at Stockport whilst working a Paddington-Manchester service and …")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 36):")])]), _vm._v(" … returned shortly after whilst working a Manchester Piccadilly-Plymouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 37):")])]), _vm._v(" Among the heritage liveries, a further special livery was adopted to highlight the importance of the British Transport Police and its continual involvement with the safety of rail travel-including trespass. The livery was applied to 47829, here seen approaching Leyland on 28 March 2002 whilst working a Glasgow Central-Poole service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 38):")])]), _vm._v(" Passing trains at Exeter St Davids on 30 April 2000 sees 47807 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lion of Vienna")]), _vm._v(" awaiting departure whilst working a Penzance-Manchester Piccadilly service as 47829 arrives whilst working a Manchester Piccadilly-Plymouth service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Virgin Cross Country ended its use of Class 47 traction on 19 August 2002 when heritage-liveried 47840 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Star")]), _vm._v(" and 47847 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Morrison/Railway World Magazine")]), _vm._v(" powered the 08:46 Penzance-Manchester Piccadilly service as far as Birmingham New St where passengers detrained to travel forward on a ‘Voyager’ trainset. The locomotives continued with their trainset to Derby, then detached to run forward to Toton Depot where the five locomotives bearing heritage livery, plus one bearing Virgin Group corporate livery, were assembled for a final line-up to mark the end of locomotive operation by Virgin Cross Country.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 39):")])]), _vm._v(" Led by 47840 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Star")]), _vm._v(", bearing its original BR TOPS number 47077, the 08:46 Penzance-Manchester Piccadilly service makes its last locomotive-hauled arrival at Birmingham New St on 19 August 2002.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 40):")])]), _vm._v(" The line-up at Toton displays (from left to right) 47851 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Traction Magazine")]), _vm._v(" in two-tone green livery, 47853 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RAIL")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EXPRESS")]), _vm._v(" in XP64 blue livery, 47840 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Star")]), _vm._v(" in BR corporate blue livery, 47847 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Morrison/Railway World Magazine")]), _vm._v(" in large logo blue livery, 47826 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Springburn")]), _vm._v(" in Inter City livery and 47805 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pride of Toton")]), _vm._v(" in Virgin Rail Group corporate livery.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 41):")])]), _vm._v(" The front ends of the heritage livery fleet.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the event, some locomotives passed to Virgin Trains (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section 2.2")]), _vm._v(") whilst the remainder were taken offlease and scrapped or made available for sale to other operators.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Note:")]), _vm._v(" Images 39-41 kindly supplied by Richard Tuplin.")]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("1.3: CLASS 86")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Virgin Cross Country inherited eighteen class 86/2 locomotives which were nominally allocated to pool ICCA based at Manchester Longsight depot for maintenance purposes. The pool allocations were:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ICCA: 86205/206/212/214/216/222/226/227/228/229/233/234/244/247/252/255/259/260")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Their service with Virgin Cross Country was short-lived as they were quickly replaced by ‘Voyager’ trainsets leading to locomotives either coming off lease or being transferred to other franchises; 86205/212/228/229/2 33/247/259/260 transferred to Virgin Trains (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section 2.5")]), _vm._v(") whilst 86209/227/234/242 (from Virgin Trains) transferred to the Inter City East Anglian franchise.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 42):")])]), _vm._v(" Nominally a locomotive from the Virgin Trains West Coast pool, 86207 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("City of Lichfield")]), _vm._v(" is on Virgin Cross Country duty as it passes Winwick on 16 October 2001 whilst working a Bristol Temple Meads-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 43):")])]), _vm._v(" 86228 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vulcan Heritage")]), _vm._v(" curves out of Crewe on 16 June 2002 whilst working a Paddington-Glasgow Central service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("At the end of 2001 and the early part of 2002, the Virgin Cross Country Edinburgh-Bournemouth service was regularly hauled by Class 86 locomotives, replete in the Virgin Rail Group corporate livery, for part of the journey. Images from that period include …")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 44):")])]), _vm._v(" … 86225 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hardwicke")]), _vm._v(" curving through Winwick on 16 October 2001.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 45):")])]), _vm._v(" … 86226 Charles "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rennie Mackintosh")]), _vm._v(" passing Leyland on 14 February 2002.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 46):")])]), _vm._v(" … 86251 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Birmingham")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Post")]), _vm._v(" passing Leyland on 26 February 2002.")])]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("1.4: CLASS 158-EXPRESS SPRINTER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Virgin Cross Country inherited 5 Class 158 ‘Express Sprinter’ trainsets, numbered 158747-751, dedicated to services from Edinburgh to Manchester Airport and Liverpool Lime St. These were the first trainsets to be displaced when the ‘Voyager’ trainsets were introduced to service during 2002/2003, hence their transfer to other franchises. They did not operate under a pool code but were maintained at Newton Heath depot on behalf of Virgin Cross Country during their period of service.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 47):")])]), _vm._v(" Unit 158749 races south through Balshaw Lane Junction on 19 February 2000 whilst working an Edinburgh-Liverpool Lime St service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 48):")])]), _vm._v(" Unit 158748 curves through Oubeck on 30 June 2001 whilst working an Edinburgh-Liverpool Lime St service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 49):")])]), _vm._v(" Unit 158747 curves through Beckfoot on 28 October 1997 whilst working an Edinburgh-Manchester Airport service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 50):")])]), _vm._v(" Units 158750 and 158747 stand in Edinburgh Waverley on 16 April 1998 after their arrival with a service from Manchester Airport.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 51):")])]), _vm._v(" Unit 158747 races through Brock on 14 January 1997 whilst working an Edinburgh-Manchester Airport service.")])]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("1.5: CLASSES 220/221")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Inter City Cross Country franchise required the replacement of the traction mix hence orders were placed for seventy-eight diesel-electric multiple unit trainsets comprising thirty-four four-car sets (classified Class 220) and forty five-car plus four four-car trainsets with tilting bogies (classified Class 221). The four-car Class 220 trainsets were ordered for the Inter City services and the Class 221 trainsets were ordered for Cross Country services, except the four-car Class 221 trainsets which were ordered to operate the Virgin Trains’ Euston-Holyhead service but, when delivered, were retained by VCC for its services.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trainsets were delivered during 2001-2003 during which time Virgin Cross Country launched ‘Operation Princess’ in September 2002 that introduced a new timetable designed to operate a clockface timetable of shorter trains running more frequently. The new timetable proved a failure, with the ‘Voyager’ fleet suffering a number of technical faults, allied to issues with National Rail’s infrastructure and capacity failures, which led to punctuality dropping to 54 per cent by January 2003. The SRA reacted by demanding cuts to certain services to improve reliability and protect services on the core network.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the beginning of the new timetable VCC had operated five main services and the SRA demands affected them as noted below:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("1.")]), _vm._v(" Birmingham New St-Swindon via Cheltenham; services were withdrawn in summer 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("2.")]), _vm._v(" Glasgow Central/Edinburgh Waverley/Blackpool North through Birmingham New St to South West England; services from Blackpool North were withdrawn in summer 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("3.")]), _vm._v(" Aberdeen/Edinburgh Waverley/Newcastle through Manchester Piccadilly and Birmingham New St to Poole; services south of Bournemouth were withdrawn in summer 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("4.")]), _vm._v(" Liverpool Lime St/Manchester Piccadilly/Manchester Airport through Birmingham New St to London Paddington/Portsmouth/Brighton; Portsmouth and London Paddington services were withdrawn in summer 2003 whilst reduced frequency of Brighton services and all Liverpool Lime St services were withdrawn in winter 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("5.")]), _vm._v(" Aberdeen/Edinburgh Waverley through Birmingham New St to Cardiff/Swansea/Paignton/Penzance; services west of Cardiff were withdrawn in summer 2003.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The remaining core services were restructured leading to concentrating on the operation of three main services:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("1.")]), _vm._v(" South West of England through Birmingham New St to the North West of England/Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("2.")]), _vm._v(" South Coast through Birmingham New St to the North of England/Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("3.")]), _vm._v(" South West of England/South East Wales through Birmingham New St to North East of England/Scotland.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A further consequence of the failure of ‘Operation Princess’ was the decision by the SRA to restructure the Cross Country franchise and ask Virgin Rail Group to provide proposals for operating both its franchises in September 2006; the DfT, as successors to the SRA since December 2006, rejected the proposals for the Cross Country franchise and issued it to open tender. The DfT awarded the franchise in June 2007 to Arriva Trains to begin from 11 November 2007.")]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec06"
    }
  }, [_vm._v("1.5.1: CLASS 220-‘VOYAGER’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The order for thirty-four trainsets was placed in 1998 as part of the franchise agreement for Cross Country services and were delivered during 2001-2003. The intention was to operate them on Virgin Cross Country’s Inter City services, but they were quickly pooled with the Class 221 ‘Super Voyagers’ on the longer Cross Country services (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec07"
    }
  }, [_vm._v("Section 1.5.2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the Inter City Cross Country franchise was taken over by Arriva Trains in November 2007, the units lost their names and all were transferred to the new operator.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 52):")])]), _vm._v(" A comparison of ‘Voyager’ units sees (left) Class 220 220008 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Draig Gymreig/Welsh Dragon")]), _vm._v(" and (right) Class 221 221134 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Kingsley")]), _vm._v(" being serviced at Manchester’s Longsight Depot on 17 November 2005. Apart from the obvious difference in bogies between the two variants, note also the ‘Virgin’ crests; the Class 220 trainset has a silver shield with red writing to identify a non-tilting trainset whilst the Class 221 trainset carries a red shield with silver writing to identify a tilting trainset.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 53):")])]), _vm._v(" An unidentified Class 220 trainset curves out of Newcastle on 12 March 2004 as it heads to Edinburgh whilst working a northbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 54):")])]), _vm._v(" 220022 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brighton Voyager")]), _vm._v(" eases through Brunel’s Tamar Bridge on 20 July 2005 as it enters Devon whilst working a Penzance-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 55):")])]), _vm._v(" 220004 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cumbrian Voyager")]), _vm._v(" approaches Ribblehead Viaduct on 24 January 2004 whilst working a Birmingham New St-Edinburgh service, diverted from the direct Preston-Carlisle route by WCML upgrade engineering works.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 56):")])]), _vm._v(" 220033 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fife Voyager")]), _vm._v(" curves through Greenholme as it ascends Shap on 28 January 2004 whilst working a Bristol Temple Meads-Glasgow Central service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 57):")])]), _vm._v(" 220024 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheffield Voyager")]), _vm._v(" curves through Greenholme as it ascends Shap on 18 April 2007 whilst working a northbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0034-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 58):")])]), _vm._v(" 220015 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Solway Voyager")]), _vm._v(" awaits departure from Edinburgh Waverley on 10 November 2004 whilst working an Edinburgh-Aberdeen service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 59):")])]), _vm._v(" 220004 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cumbrian Voyager")]), _vm._v(" calls at Preston on 11 March 2003 whilst working a Birmingham International-Blackpool North service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 60):")])]), _vm._v(" 220022 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brighton Voyager")]), _vm._v(" and 220011 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tyne Voyager")]), _vm._v(" rest at Preston on 29 March 2002 after working a Portsmouth-Blackpool North service that had returned to Preston for overnight cleaning.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 61):")])]), _vm._v(" 220004 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cumbrian Voyager")]), _vm._v(" leads Class 221 four-car trainset 221143 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auguste Picard")]), _vm._v(" through Dawlish on 27 April 2004 whilst working a Penzance-Dundee service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 62):")])]), _vm._v(" 220025 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Severn Voyager")]), _vm._v(" awaits departure from Blackpool North on 18 February 2003 whilst working a service to Birmingham International.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 63):")])]), _vm._v(" 220013 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gwibiwr de Cymru/South Wales Voyager")]), _vm._v(" curves through the approach to Chorley on 18 October 2003 whilst working a southbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 64):")])]), _vm._v(" 220031 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tay Voyager")]), _vm._v(" races through Brock on 19 July 2007 whilst working a southbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 65):")])]), _vm._v(" 220021 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackpool Voyager")]), _vm._v(" races through Brock on 12 May 2006 whilst working a southbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 66):")])]), _vm._v(" 220016 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Midland Voyager")]), _vm._v(" curves through Clay Cross on 9 November 2007 with a southbound Cross Country service. Despite the trainset being due to be transferred to the new franchisee two days later, the trainset still carries full Virgin Rail Group corporate livery and branding.")])]), _vm._v(" "), _c('h3', {
    staticClass: "section",
    attrs: {
      "id": "sec07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("1.5.2: CLASS 221-‘SUPER VOYAGER’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The order for forty five-car and four four-car trainsets for the Inter City West Coast franchise Euston-Holyhead services was placed in 1998 as part of the Inter City Cross Country franchise agreement and they were delivered during 2001-2003. In order to speed their introduction to service, many Class 221 trainsets were initially delivered as four-car units with the additional vehicle being supplied once the full order had been delivered. These units were fitted with tilting bogies to operate them on the high speed lines traversed by the franchise’s Cross Country services but they quickly became common on all services in conjunction with the Class 220 trainsets (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec06"
    }
  }, [_vm._v("Section 1.5.1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the franchise was taken over by Arriva Trains in November 2007, units 221119-141 lost their names and were transferred to the new operator whilst units 221101-118; 221142-144 transferred to the revised Inter City West Coast franchise along with the services from Birmingham New St to Edinburgh/Glasgow Central. Arriva Trains immediately began modifying its fleet of Class 220 ‘Voyager’ and Class 221 ‘Super Voyager’ trainsets hence 221114-118 remained on loan to the new franchisee for 12 months until the modification programme was completed.")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0038-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 67):")])]), _vm._v(" Class doyen 221101 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Louis Bleriot")]), _vm._v(" is operating as a 5-car trainset when it enters Devon on 20 July 2005 as it eases off the Tamar Bridge whilst working a Penzance-Dundee service.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("The Class 221 trainsets were initially delivered as four-car trainsets:")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 68):")])]), _vm._v(" 221116 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Livingstone")]), _vm._v(" leads 221102 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Cabot")]), _vm._v(" as they curve through Beckfoot on 28 May 2002 whilst working an Edinburgh-Bournemouth service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 69):")])]), _vm._v(" Four-car trainset 221141 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amerigo Vespucci")]), _vm._v(" curves through Oubeck on 2 November 2006 whilst working an Edinburgh-Manchester Piccadilly service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 70):")])]), _vm._v(" 221119 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amelia Earhart")]), _vm._v(" enters Stockport on 17 August 2002 whilst engaged in driver training duties between Manchester Piccadilly and Stafford.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 71):")])]), _vm._v(" A Class 221 ‘Super Voyager’ trainset climbs through Leyland on 24 April 2002 whilst working an Edinburgh-Brighton service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 72):")])]), _vm._v(" 221142 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Matthew Flinders")]), _vm._v(" calls at Bolton on 23 January 2007 whilst working an Edinburgh-Manchester Piccadilly service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 73):")])]), _vm._v(" 221104 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sir John Franklin")]), _vm._v(" leads Class 220 220030 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Devon Voyager")]), _vm._v(" as they curve through Chorley on 9 May 2002 whilst working a Bournemouth-Edinburgh service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 74):")])]), _vm._v(" A Class 221 ‘Super Voyager’ trainset curves through the Lune Gorge on 22 March 2005 whilst working a northbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 75):")])]), _vm._v(" An unidentified ‘Super Voyager’ trainset crosses Whalley Viaduct on 29 April 2006 whilst working a Birmingham New St-Carlisle service, diverted from the direct Preston-Carlisle route by WCML upgrade engineering works.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 76):")])]), _vm._v(" An unidentified ‘Super Voyager’ trainset crosses the Forth Bridge on 16 August 2007 whilst working a Plymouth-Aberdeen service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 77):")])]), _vm._v(" 221138 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thor Heyerdahl")]), _vm._v(" curves through Greenholme on 18 April 2007 as it ascends Shap whilst working a northbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 78):")])]), _vm._v(" 221137 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mayflower Pilgrims")]), _vm._v(" curves through Oubeck on 7 June 2007 whilst working a southbound Cross Country service.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("(Image 79):")])]), _vm._v(" 221120 has lost both name and branding in preparation for its transfer to the next franchisee, Arriva Trains, two days later as it passes Clay Cross on 9 November 2007 whilst working a southbound Cross Country service.")])]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#fnintseci_*",
      "id": "rfnintseci_*"
    }
  }, [_vm._v("*")]), _vm._v(" Power cars 43013/014/065/067/068/080/084/123 were those that had been fitted with buffers and Class 91 driving controls to operate in top‘n’tail mode with the pre-production Class 91 locomotives (91001-010) during the early days of the East Coast electrification in the 1990s.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#fnintseci_**",
      "id": "rfnintseci_**"
    }
  }, [_vm._v("**")]), _vm._v(" Following the major accident at Southall on 19 September 1997, the Great Western franchise had elected to fit Automatic Train Protection (ATP) to its HST Power cars hence exchanged its non-ATP fitted 43006/007/008/178/184 (transferred from Cross Country Trains during 1997) for the ATP-fitted 43028/041/042/164/165 operated by the Virgin Trains West Coast franchise whilst the Virgin Cross Country power cars were re-allocated between Longsight and Laira Depots.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d157ad6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Section1.vue
// module id = 78
// module chunks = 0